import React, { useState } from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning"; // Corrigindo importação
import Swal from "sweetalert2";

export default function TextFieldCPF(props) {
  const [error, setError] = useState(false);

  // Formatação do CPF
  const formatCPF = (value) => {
    return value
      .replace(/\D/g, "") // Remove tudo que não for número
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1-$2")
      .slice(0, 14); // Garante o tamanho correto
  };

  // Validação do CPF
  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, ""); // Remove a formatação

    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false; // CPFs inválidos conhecidos

    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++) soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
  };

  const handleChange = (event) => {
    const newValue = formatCPF(event.target.value);
    const isValid = newValue.length === 14 && validateCPF(newValue);

    setError(!isValid); // Define o erro

    if (props.onChange) {
      props.onChange({
        ...event,
        target: { ...event.target, value: newValue },
      });
    }
  };

  return (
    <TextField
      {...props}
      error={error}
      helperText={error ? "CPF inválido" : ""}
      value={props.value || ""}
      onChange={handleChange}
      InputProps={{
        endAdornment: error ? (
          <InputAdornment position="end">
            <WarningIcon color="error" />
          </InputAdornment>
        ) : null,
      }}
      onBlur={() => {
        if (error) {
          Swal.fire({
            title: "Corporate Web",
            text: "O CPF informado é inválido! Verifique!",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }}
    />
  );
}
